export const SENSOR_TYPE_OPTIONS = [
  { id: 'SST', display: 'SST' },
  { id: 'Tirecheck', display: 'Tirecheck' },
  { id: 'DG', display: 'DG' },
] as const;

export type SensorType = (typeof SENSOR_TYPE_OPTIONS)[number]['id'];
